import Vue from 'vue'
import HomeApp from './Theme0222_2'

/* eslint-disable no-new */
new Vue({
    el: '#home-app',
    template: '<HomeApp/>',
    components: { HomeApp }
})


// WEBPACK FOOTER //
// ./src/h5/theme0222_2/index0222_2.js